export default "__VITE_ASSET__18964f8e__"